import React from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import Button from "../../../buttons/Button";
import { useStripeDone } from "../../../../hooks/useStripeStatus";

const Bank = ({ tKey = "dashboard.settings.bank.", restaurantId }) => {
  const { t } = useTranslation();
  const { isStripeDone, stripeUrl } = useStripeDone(restaurantId);

  const handlePaymentSetupClick = () => {
    if (stripeUrl) {
      window.open(stripeUrl, "_blank");
    } else {
      toast.warning(t("dashboard.restaurant.activationIncomplete"));
    }
  };

  return (
    <div className="dashboard-content">
      <div className="w-100 h-100 bg-white rounded p-3 flex align-center justify-center">
        <Button variant="danger" onClick={handlePaymentSetupClick}>
          {t(`${tKey}${isStripeDone ? "update" : "setup"}`)}
        </Button>
      </div>
    </div>
  );
};

export default Bank;
